import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
  SimpleLoading,
  InstructionsPure,
  ButtonHLPure,
} from "../../pures";
import "./dialog-template.css";

/* === Dialog component form signer === */
const DialogTemplatePure = (props) => {
  const {
    loadingComponent,
    cancel,
    saveError,
    title,
    description,
    handleSubmitProfile,
    saveBtn,
    canelBtn,
    buttonStyles,
    profiles,
    userId,
    userName,
    children,
    buttonCustomStyles
  } = props;

  let dialogCollaboratorWidth = loadingComponent ? 590 : 600;
  let dialogCollaboratorHeight = loadingComponent ? 430 : 580;

  return (
    // <div style={props.showErrorDomain === true ? { display: 'none' } : null}>
    <Dialog
      width={dialogCollaboratorWidth}
      height={dialogCollaboratorHeight}
      className="dialogTemplatePure-container"
      title={title}
      onClose={cancel}
    >
      {loadingComponent && (
        <div>
          <SimpleLoading />
        </div>
      )}

      {!saveError && !loadingComponent && (
        <form>
          <div className="dialogTemplatePure-body-dialog">
            {description && <InstructionsPure instructions={description} />}
            {children}
            <div
              item="true"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className={buttonStyles ?? "dialogTemplatePure-btns-container"}
            >
              <div className="dialogTemplatePure-btn-cancel">
                <ButtonHLPure
                  style={buttonCustomStyles}
                  nameBtn={canelBtn}
                  onClickBtn={cancel}
                />
              </div>
              <ButtonHLPure
                primary
                nameBtn={saveBtn}
                onClickBtn={(e) => handleSubmitProfile(e)}
              />
            </div>
          </div>
        </form>
      )}
    </Dialog>
    // </div>
  );
};

export { DialogTemplatePure as default };
